import { useEffect, useState } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import { ReceivedEmailApi, ReceivedEmailDataType } from "@/api/ReceivedEmailApi";
import { ReceivedAttachmentApi, ReceivedAttachmentDataType } from "@/api/ReceivedAttachmentApi";
import SecureHTMLRender from "@components/content/SecureHTMLRender";
import { Col, Row } from "reactstrap";
import styles from "./style.module.scss";
import AttachmentDownloadLink from "@components/content/AttachmentDownloadLink";
import { pickEmailBody } from "@utils/emailBody";


const ViewReceivedInvoice = () => {
  const params = useParams();
  const { recievedEmailId } = params;
  const [emailData, setEmailData] = useState<ReceivedEmailDataType>({})
  const [emailAttachments, setEmailAttachments] = useState<ReceivedAttachmentDataType[]>([])

  useEffect(() => {
    if (recievedEmailId) {
      loadEmailData(recievedEmailId);
    }
  }, [recievedEmailId]);

  const loadEmailData = async (recievedEmailId: string) => {
    const { items: attachments } = await ReceivedAttachmentApi.getByRecievedEmailId(recievedEmailId);
    setEmailAttachments(attachments)

    const email = await ReceivedEmailApi.get(recievedEmailId);
    setEmailData(email)

  }

  const renderAttachments = () => {
    if (emailAttachments && emailAttachments.length > 0) {
      return (
        <div className={styles.fileAttachmentGrid}>
          <b>Adjuntos:</b>
          {emailAttachments.map(ae => (
            <AttachmentDownloadLink
              key={ae.s3Key}
              bucketName="recievedProviderEmails"
              item={{
                label: `${ae.filename}`,
                s3Key: `${ae.s3Key}`,
                fileType: `${ae.mimeType}`.includes("pdf") ? "pdf" : "xml",
              }}
            />
          ))}
        </div>
      )
    }
  }

  const renderBody = () => {
    const { content, isPlainText, isEmpty } = pickEmailBody(emailData);

    if (isEmpty) {
      return (
        <p data-testid="email-empty-body">
          Este correo no tiene contenido; revise los adjuntos.
        </p>
      )
    }

    return (
      <SecureHTMLRender
        htmlBody={content}
        isPlainText={isPlainText}
      />
    )
  }

  return (
    <PageContainer
      title="Ver Correo De Factura Electronica"
      backUrl="/user/receivedInvoices"
    // primaryActions={[{
    //   actionTitle: "Enviar Mensaje de Documento",
    //   color:"success",
    //   onClick: () => {
    //     OpenSendDocumentMessageAsPubSub.publish({
    //       openOffCanvas: true,
    //       invoiceAttachmentId: `${emailData.xmlInvoiceAttachmentId}`
    //     })
    //   }
    // },
    // ]}
    >

      <Row>
        <Col
          xs="2"
          md="1"
        >
          <b>De:</b>
        </Col>
        <Col>
          {emailData?.from}
        </Col>
      </Row>
      <Row>
        <Col
          xs="2"
          md="1"
        >
          <b>Asunto:</b>
        </Col>
        <Col>
          {emailData?.subject}
        </Col>
      </Row>
      <hr />
      {renderAttachments()}
      <Row>
        <Col>
          {renderBody()}
        </Col>
      </Row>


    </PageContainer >
  );
}

export default ViewReceivedInvoice;
